import { createAction, props } from '@ngrx/store';
import { Cuenta, CuentaForm } from '@core/models';
import { ResponseBadRequest } from '@core/interfaces';

export const ACCOUNT_FIND = createAction('[Account] Find', props<{ id: string }>());
export const ACCOUNT_FIND_ALL = createAction('[Account] Find All', props<{ resellerId?: string, name?: string }>());

export const ACCOUNT_FIND_SUCCESS = createAction('[Account] Find Success', props<{ account: Cuenta }>());
export const ACCOUNT_FIND_ALL_SUCCESS = createAction('[Account] Find All Success', props<{ accountList: Cuenta[] }>());

export const ACCOUNT_FAILURE = createAction('[Account] Failure', props<{ error: ResponseBadRequest }>());

export const ACCOUNT_UPDATE_LOADING = createAction('[Account] Update Loading', props<{ loading: boolean }>());
export const ACCOUNT_UPDATE_FORM = createAction('[Account] Update Form', props<{ accountForm: CuentaForm }>());
export const ACCOUNT_EDIT_MODE = createAction('[Account] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const ACCOUNT_UPDATE_ID = createAction('[Account] Update Id', props<{ accountId: string | null }>());

export const ACCOUNT_CREATE_VIEW = createAction('[Account] Create View');
export const ACCOUNT_UPDATE_VIEW = createAction('[Account] Update View', props<{ accountId: string }>());

export const ACCOUNT_CREATE = createAction('[Account] Create');
export const ACCOUNT_UPDATE = createAction('[Account] Update');
export const ACCOUNT_ACTIVATE = createAction('[Account] Activate', props<{ id: string }>());
export const ACCOUNT_DEACTIVATE = createAction('[Account] Deactivate', props<{ id: string, razonInactivacion: string }>());
export const ACCOUNT_REMOVE = createAction('[Account] Remove', props<{ id: string }>());

export const ACCOUNT_CREATE_COMPLETED = createAction('[Account] Create Completed');
export const ACCOUNT_UPDATE_COMPLETED = createAction('[Account] Update Completed');
export const ACCOUNT_REMOVE_COMPLETED = createAction('[Account] Remove Completed');
export const ACCOUNT_ACTIVATE_COMPLETED = createAction('[Account] Activate Completed');
export const ACCOUNT_DEACTIVATE_COMPLETED = createAction('[Account] Deactivate Completed');

export const ACCOUNT_RESET = createAction('[Account] Reset');
export const ACCOUNT_RESET_FORM = createAction('[Account] Reset Form');
export const ACCOUNT_RESET_ERROR = createAction('[Account] Reset Error');
export const ACCOUNT_CLEAR_STATE = createAction('[Account] Clear State');
